<div>
	<div class="row">
		<div class="col-lg-5">
			<div class="map-panel">
				@if (bounds === undefined) {
					<div class="loading-status">
						<div class="logo-spin"></div>
						Loading map data...
					</div>
				}
				@if (bounds === null) {
					<div class="loading-status">
						<div class="logo-spin stopped"></div>
						No map data available for this operation.
					</div>
				}
				@if (bounds) {
					<google-map #googleMap width="100%" height="400px" [options]="mapOptions" (idle)="mapLoaded()">
						@if (path) {
							<map-marker [position]="path[path.length - 1]" [options]="stopMarkerOptions"></map-marker>
						}
						@if (path) {
							<map-marker [position]="path[0]" [options]="startMarkerOptions"></map-marker>
						}
						@if (mapInfoPosition) {
							<map-marker [position]="mapInfoPosition" [options]="markerOptions"></map-marker>
						}
						@if (path) {
							<map-polyline [path]="path" [options]="polylineOptions"></map-polyline>
						}
					</google-map>
				}
			</div>
		</div>
		<div class="col-lg-7">
			<div>
				@if (operation && operation.e1_turb !== null) {
					<div class="row mb-3">
						<div class="col-md-3">Engine 1 Cycles:</div>
						<div class="col-md-3">Turbine: {{ operation.e1_turb | number : "1.0-3" | ifempty : "No data" }}</div>
						<div class="col-md-3">Compressor: {{ operation.e1_comp | number : "1.0-3" | ifempty : "No data" }}</div>
						<div class="col-md-3">Impeller: {{ operation.e1_imp | number : "1.0-3" | ifempty : "No data" }}</div>
					</div>
				}
				@if (operation && operation.e2_turb !== null) {
					<div class="row mb-3">
						<div class="col-md-3">Engine 2 Cycles:</div>
						<div class="col-md-3">Turbine: {{ operation.e2_turb | number : "1.0-3" | ifempty : "No data" }}</div>
						<div class="col-md-3">Compressor: {{ operation.e2_comp | number : "1.0-3" | ifempty : "No data" }}</div>
						<div class="col-md-3">Impeller: {{ operation.e2_imp | number : "1.0-3" | ifempty : "No data" }}</div>
					</div>
				}
				@if (operation && operation.distance !== null) {
					<div class="row mb-3">
						<div class="col-lg-4">Distance: {{ operation.distance | number : "1.0-3" | ifempty : "No data" }}</div>
					</div>
				}
				@if (exceedances && exceedances.length) {
					<div>
						<table class="log">
							<thead>
								<tr>
									<th width="22px"></th>
									<th>Time</th>
									<th>Exceedance</th>
									<th>Description</th>
									<th>Duration</th>
								</tr>
							</thead>
							@for (exceed of exceedances; track exceed) {
								<tbody>
									<tr>
										<td>
											<div class="alert-light" [ngClass]="{ 'error': exceed.severity === 1, 'warning': exceed.severity !== 1 }"></div>
										</td>
										<td>{{exceed.timestamp | datetime : "time" : (fleet ? fleet.time_offset_hours : 0) }}</td>
										<td>{{exceed.name}}</td>
										<td>{{exceed.description}}</td>
										<td>{{exceed.duration | duration}}</td>
									</tr>
								</tbody>
							}
						</table>
						<div class="mb-3 form-check mt-3">
							<label>
								<input [(ngModel)]="ackChecked" [disabled]="this.api.user.role === 'readonly'" (ngModelChange)="UpdateAcknowledged()" type="checkbox">
								Acknowledge all exceedances for this operation
							</label>
						</div>
						@if (ackUser) {
							<div>Acknowledged by {{ackUser}} on
								{{ackTime | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}
							</div>
						}
					</div>
				}
				@if (exceedances === undefined) {
					<div class="loading-status">
						<div class="logo-spin"></div>
						Loading exceedances...
					</div>
				}
				@if (exceedances && !exceedances.length) {
					<div class="loading-status">
						<div class="logo-spin stopped"></div>
						No exceedances have been recorded for this operation.
					</div>
				}
			</div>
		</div>
	</div>
	<div class="mt-5">
		<app-dvs-chart [error]="chartErrorMessage" [options]="chartOptions" loading="Loading FDM data..." [height]="'300px'"
			[timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
		@if (graphParams) {
			<div class="mt-3">
				<div class="row">
					@for (prop of graphParams; track prop) {
						<div class="col-sm-4 col-lg-3">
							<label>
								<input type="checkbox" [(ngModel)]="prop.selected" (ngModelChange)="refreshChart()"> {{prop.name}}
							</label>
						</div>
					}
				</div>
				<div class="row mt-4">
					<div class="col-sm-4 offset-sm-2 text-center">
						<button (click)="ClearSelections()" class="button wide nowrap">Clear selections</button>
					</div>
					<div class="col-sm-4 text-center mt-xs">
						<button (click)="ExportStates()" class="button wide nowrap">Download State Data <i class="green leftpad icon-download"></i></button>
					</div>
				</div>
			</div>
		}
	</div>
	@if (components.enable_counts_gui) {
		<div class="panel expander collapsed mt-5">
			<div class="heading" (click)="$event.target.parentElement.classList.toggle('collapsed')">Counts over time</div>
			<div class="content">
				<div class="row">
					<div class="col-lg-4">
						If available, you may calculate total counts or distance over a date range
					</div>
					<div class="col-lg-4">
						Start
						<app-day-picker [(ngModel)]="startDate" (ngModelChange)="QueryCounts()"></app-day-picker>
					</div>
					<div class="col-lg-4">
						End
						<app-day-picker [(ngModel)]="endDate" (ngModelChange)="QueryCounts()"></app-day-picker>
					</div>
				</div>
				@if (countData) {
					<div class="count-results">
						<div class="row mt-4">
							<div class="col-md-3"><b class="white">Engine 1 Cycles</b></div>
							<div class="col-md-3"><b>Turbine:</b> {{ countData.e1_turb | number : "1.0-3" | ifempty : "No data" }}</div>
							<div class="col-md-3"><b>Compressor:</b> {{ countData.e1_comp | number : "1.0-3" | ifempty : "No data" }}</div>
							<div class="col-md-3"><b>Impeller:</b> {{ countData.e1_imp | number : "1.0-3" | ifempty : "No data" }}</div>
						</div>
						@if (countData.e2_turb !== null) {
							<div class="row mt-4">
								<div class="col-md-3"><b class="white">Engine 2 Cycles</b></div>
								<div class="col-md-3"><b>Turbine:</b> {{ countData.e2_turb | number : "1.0-3" | ifempty : "No data" }}</div>
								<div class="col-md-3"><b>Compressor:</b> {{ countData.e2_comp | number : "1.0-3" | ifempty : "No data" }}</div>
								<div class="col-md-3"><b>Impeller:</b> {{ countData.e2_imp | number : "1.0-3" | ifempty : "No data" }}</div>
							</div>
						}
						<div class="row mt-4">
							<div class="col-md-3"><b class="white">Total</b></div>
							<div class="col-md-3"><b>Distance:</b> {{ countData.distance | number : "1.0-3" | ifempty : "No data" : " km" }}</div>
							<div class="col-md-3"><b>Flight Time:</b> {{ countData.flight_time | runtime | ifempty : "No data" }}</div>
							<div class="col-md-3"><b>Rotor Turn Time:</b> {{ countData.rotor_turn_time | runtime | ifempty : "No data" }}</div>
						</div>
						<div class="mt-4">
							{{countData.opcount}} active operations&nbsp;
							@if (countData.opcount > 0) {
								<span>(<a (click)="DownloadActiveOperations()" href="javascript:void(0)" class="font-weight-bold">download CSV</a>)</span>
							}
						</div>
					</div>
				}
			</div>
		</div>
	}
</div>